<template>
  <v-card elevation="0" class="ma-0 pa-0 px-5 transparent rounded-lg">
    <v-row justify="space-between" align="center">
      <v-col cols="12" md="auto">
        <v-row align="center" justify="space-between">
          <v-col cols="12" sm="auto" class="d-flex justify-center align-center">
            <div class="subtitle-2 gray6--text  font-weight-medium">
              {{ pageData.main | capitalize }}
              <v-icon size="5" color="gray6" class="mx-1">mdi-circle
              </v-icon>
            </div>
            <div class="text-h6 mx-2 primary--text  text-capitalize">
              <strong v-text="pageData.entityName" />
            </div>
          </v-col>
          <v-col class="px-0 d-none d-md-block" v-if="showSearch || dateRange">
            <v-divider vertical style="height: 25px" class="d-block ma-auto"></v-divider>
          </v-col>
          <v-col cols="12" lg="auto" sm="auto" class="py-0" v-if="showSearch">
            <v-text-field v-model="pageData.search" @keydown.enter="(e) => getSearch(e.target.value)"
              @click:clear="(e) => getSearch(e.target.value)" class="rounded-pill"
              @click:append="getSearch(pageData.search)" append-icon="mdi-magnify" :placeholder="
                pageData.isTrashed == 0 ? $i18n.t('Search in deleted') : $i18n.t('Search')
              " single-line clearable hide-details solo dense :height="37"></v-text-field>
          </v-col>
          <GenericInput type="date" :solo="true" classes="rounded-lg" v-if="dateRange" :value="pageData.from"
            @input="pageData.from = $event" label="from" :required="false" :hide-details="true"
            :isLoading="pageData.editIsLoading" :cols="[12, 'auto', 'auto']">
          </GenericInput>
          <GenericInput type="date" :solo="true" classes="rounded-lg" v-if="dateRange" :value="pageData.to"
            @input="pageData.to = $event" label="to" :required="false" :hide-details="true"
            :isLoading="pageData.editIsLoading" :cols="[12, 'auto', 'auto']"></GenericInput>
        </v-row>
      </v-col>
      <v-col cols="12" md="auto" class="pa-sm-0">
        <v-row justify="center" justify-md="end" align="center">
          <v-col cols="auto" class="pa-md-0" v-if="showDeleted && $global.CheckAction(this.pageData.screen_code, 4)">
            <v-btn outlined class="rounded-lg mx-2" style="background-color:  #e6ecff ;" v-if="pageData.isTrashed == 0"
              @click="pageData.isTrashed = 1; getData();" depressed color="blue2" :height="37">
              <img src="@/assets/img/svg_icons/pin.svg" height="16" class="mx-1" alt="cement" />
              {{ $t('pin') }}
            </v-btn>
            <v-btn depressed outlined class="rounded-lg mx-2" color="error" style="background-color:  #feeaea ;"
              v-if="pageData.isTrashed == 1" @click="pageData.isTrashed = 0; pageData.page = 1; getData();"
              :height="37">
              <img src="@/assets/img/svg_icons/delete.svg" height="16" class="mx-1" alt="cement" />
              {{ $t('deleted') }}
            </v-btn>
          </v-col>
          <v-col cols="auto" v-if="actionBtn == true">
            <v-btn depressed @click="actionBtnClick" :outlined="actionBtnOutline" :loading="pageData.isLoading"
              :disabled="!actionBtnValid" class="my-2 rounded-lg" :class="actionBtnClass" :color="actionBtnColor"
              :height="37">
              <v-icon size="18" left v-if="actionBtnIcon">{{ actionBtnIcon }}</v-icon>
              <span>{{ $t(actionBtnText) }}</span>
            </v-btn>
          </v-col>
          <v-col cols="auto" v-if="createBtn && $global.CheckAction(this.pageData.screen_code, 2)">
            <v-btn depressed :min-width="90" @click="createBtnClicked" class="my-2 rounded-lg" color="success"
              :height="37">
              {{ $t(createBtnText) }}
            </v-btn>
          </v-col>

        </v-row>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import GenericInput from "./GenericInput.vue";
const { mapState, mapActions } = createNamespacedHelpers("Settings");
export default {
  name: "EntityHeader",
  computed: {
    ...mapState(["favourites"]),
  },
  props: {
    pageData: { default: {} },
    getData: { type: Function },
    getSearch: { type: Function },
    createBtn: { default: true },
    createBtnText: { default: "create" },
    sortButton: { default: false },
    actionBtn: { default: false },
    actionBtnColor: { default: "accent" },
    actionBtnValid: { default: false },
    actionBtnClick: { type: Function },
    actionBtnText: { default: "action btn" },
    actionBtnClass: { default: "white--text" },
    actionBtnIcon: { default: null },
    showSetting: { default: false },
    showFilter: { default: false },
    showSearch: { default: true },
    showDeleted: { default: true },
    dateRange: { default: false },
    actionBtnOutline: { default: false },
  },
  methods: {
    ...mapActions(["addFavourites"]),
    addToFav() {
      const fav = {
        screen_code: this.pageData.screen_code,
        name: this.pageData.entityName,
        url: this.pageData.url,
      };
      this.addFavourites(fav).finally(() => { });
    },
    createBtnClicked() {
      if (this.pageData.controlRoute) {
        this.$router.push('/' + this.pageData.controlRoute)
      }
      else {
        this.pageData.controlID = null;
        this.pageData.controlDialog = true;
      }
    }
  },
  components: { GenericInput }
};
</script>

<style scoped lang="scss">

</style>
